import React from 'react';
import { ListGroup, Card } from 'react-bootstrap';
const CurrentClaimYear = _ref => {
  let {
    dashboardData,
    selectedYears,
    selectYear,
    isMultipleYearsEnabled,
    setIsMultipleYearsEnabled,
    isBusinessUnitDashboardType
  } = _ref;
  return /*#__PURE__*/React.createElement(Card, {
    className: "p-2 dashboard-business-unit-selector-card"
  }, /*#__PURE__*/React.createElement(ListGroup, null, dashboardData.dashboard_years.map(year => /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "busines-unit-item mb-1",
    key: year,
    active: selectedYears.includes(year),
    action: true,
    onClick: () => selectYear(Number(year))
  }, year))));
};
export default CurrentClaimYear;